"use client"

import { motion } from "framer-motion"
import { ArrowRight, Sparkles } from "lucide-react"
import { useAuth0 } from "@auth0/auth0-react";

export default function CTA() {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  return (
<section className="w-full max-w-4xl mx-auto px-4 py-10">
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className="w-full rounded-2xl bg-gradient-to-r from-orange-500 via-rose-500 to-red-500 px-6 py-12 md:px-12 relative overflow-hidden"
  >
        {/* Background Pattern */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute w-[400px] h-[400px] -top-48 -right-24 bg-white/10 rounded-full blur-3xl" />
          <div className="absolute w-[400px] h-[400px] -bottom-32 -left-16 bg-black/10 rounded-full blur-3xl" />
        </div>

        <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-12">
          <div className="space-y-8">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center bg-white/10 backdrop-blur-sm text-white text-sm font-semibold px-5 py-2.5 rounded-full shadow-lg border border-white/20"
            >
              <Sparkles className="w-4 h-4 mr-2" />
              BOOST YOUR RESULTS
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-4xl md:text-5xl lg:text-7xl font-bold text-white max-w-2xl tracking-tight leading-tight"
            >
              Smarter SEO, <span className="drop-shadow-md">Faster Growth.</span>
            </motion.h2>
          </div>

          {/* Enhanced CTA Button */}
          <motion.div
  initial={{ opacity: 0, x: 20 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ delay: 0.4 }}
  className="flex-shrink-0"
>
  <button
    onClick={() => loginWithRedirect()}
    className="group relative inline-flex items-center justify-center gap-2.5 rounded-full 
      px-8 py-4 text-lg font-semibold text-gray-900 transition-all duration-300 
      hover:scale-105 shadow-lg hover:shadow-xl active:scale-100 overflow-hidden"
  >
    {/* Text and icon */}
    <span className="relative z-10 duration-300 ">Try It Free</span>
    <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 relative z-10" />

    {/* Base White Background (non-hover state) */}
    <div className="absolute inset-0 bg-white rounded-full z-0 transition-opacity duration-300" />

  </button>
</motion.div>

        </div>

        {/* Enhanced Feature List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="relative flex flex-col sm:flex-row justify-center items-center sm:items-stretch gap-4 mt-12"
        >
          {[
            { text: "Set up in minutes", delay: 0.6 },
            { text: "No commitment", delay: 0.7 },
            { text: "AI-powered optimization", delay: 0.8 },
          ].map(({ text, delay }, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay }}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/10"
            >
              <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center">
                <span className="text-white">✓</span>
              </div>
              <span className="text-white font-medium">{text}</span>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  )
}

